export default __webpack_public_path__ + "static/media/area-rug.a47c9415.png";